import { Typography } from '@mui/joy';
import { TrashSimple } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Confirmation } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { useProjectCustomerActions } from 'pricing/hooks';
import { Color, Level } from 'theme/enums';

interface IProps extends ICellRendererParams {
  pricingProfileId: number;
  projectId: number;
}

export const ActionsCell = ({ data, pricingProfileId, projectId }: IProps) => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const { t } = useTranslation();

  const { updateRows } = useAgGridClientTableContext();

  const { removeProjectCustomer } = useProjectCustomerActions();

  const onRemove = useCallback(async () => {
    if (!data) {
      return;
    }

    setIsConfirmationOpen(false);

    const { success } = await removeProjectCustomer({
      contactGroup: data.id,
      pricingProfile: pricingProfileId,
      project: projectId,
    });

    if (success) {
      updateRows({ remove: [data] });
    }
  }, [data, pricingProfileId, projectId, removeProjectCustomer, updateRows]);

  if (!data) {
    return null;
  }

  return (
    <>
      <Typography
        color={Color.DANGER}
        level={Level.BODY_SM}
        sx={{ cursor: 'pointer' }}
        onClick={() => setIsConfirmationOpen(true)}
      >
        <TrashSimple />
      </Typography>

      <Confirmation
        isOpen={isConfirmationOpen}
        title={t('titleRemoveCustomer_one')}
        message={t('messageConfirmRemoveProjectCustomer', { name: data.name })}
        confirmBtnLabel={t('buttonLabelRemove')}
        confirmBtnColor={Color.DANGER}
        onConfirm={onRemove}
        onCancel={() => setIsConfirmationOpen(false)}
      />
    </>
  );
};
